
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../../service/shared.service';
import { SiteLanguageService } from '../../service/site-language.service';

const APPLICATION_CARD_KEYS = {
    salesTypeTitle: 'yediEminApplicationCardSalesTypeTitle',
    salesIndividualButton: 'yediEminApplicationCardSalesIndividualButton',
    salesCorporateButton: 'yediEminApplicationCardSalesCorporateButton',
};

@Component({ 
    selector: 'application-card',
    templateUrl: './application-card.component.html',
    styleUrls: ['./application-card.component.css']
})
export class ApplicationCardComponent extends SiriusBaseComponent<any> implements OnDestroy {       
    @Input('Link') link: string = "";
    @Input('ImgUrl') imgUrl: string = "";
    @Input('Text') text: string = "";
    @Input('TitleText') titleText: string = "";
    @Input('popuptype') popOver: string = "";
    showPopOver: boolean = false;

    salesTypeTitle = 'Satış Türü';
    salesIndividualButtonText = 'Bireysel';
    salesCorporateButtonText = 'Tüzel';

    private langSub: Subscription;

    constructor(private commonService: CommonService, private siteLanguage: SiteLanguageService) {
        super();
    }

    OnInit() {
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => {
            this.loadResourceStrings();
        });
    }

    ngOnDestroy(): void {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    private loadResourceStrings(): void {
        this.salesTypeTitle = this.commonService.getStringResource(APPLICATION_CARD_KEYS.salesTypeTitle, this.salesTypeTitle);
        this.salesIndividualButtonText = this.commonService.getStringResource(APPLICATION_CARD_KEYS.salesIndividualButton, this.salesIndividualButtonText);
        this.salesCorporateButtonText = this.commonService.getStringResource(APPLICATION_CARD_KEYS.salesCorporateButton, this.salesCorporateButtonText);
    }

    goMenu() {
        if (this.link != null && this.link != "") {
            this.startTransaction(this.link);
        }
        else if (this.popOver == "sales"){
            this.toggleSalesPopOver(); 
        }           
    }
    toggleSalesPopOver() {
        this.showPopOver = !this.showPopOver;
    }
}
